module.exports = __webpack_public_path__ + "img/slogan-preview1.045a8d74.jpg";